import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'

// Component for the progress area for the retake mode screen
function QuizProgressArea (props) {
  const { activityScore, scoreTarget } = props
  const progressBarLabel = `You currently have ${activityScore} points out of a target total of ${scoreTarget} points.`
  const headingLabel = props.isRetake ? 'Practice Quiz Progress' : 'Quiz Progress'
  return (
    <div data-test-id="progressArea">
      <h2 className={style.targetScoreHeader}>{headingLabel}</h2>
      <Row>
        <Col sm={12} xs={12}>
          <CustomProgressBar
            dataTestId="progressBar"
            now={activityScore}
            min={0}
            max={scoreTarget}
            ariaLabel={`You have ${activityScore} points.`}
            progressBarStyle={progressBarStyle}
            style={style}
            className={classnames(progressBarStyle.base, style.progressBar)}
            bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
          />
          <span>
            <span className="sr-only">{progressBarLabel}</span>
            <span className={style.pointsText}>
              <span className={style.activityScoreValue}>
                <span aria-hidden="true" className={style.targetScoreLabel}>You have:</span> {activityScore}
                <span className={style.targetScoreLabel}> pts</span>
              </span>
            </span>
          </span>
          <div className={style.targetScoreContainer}>
            <span className={style.targetScoreText}>
                Target: <span className={style.targetScoreValue}>{scoreTarget}</span>
            </span>
          </div>
        </Col>
      </Row>
    </div>
  )
}

QuizProgressArea.propTypes = {
  activityScore: PropTypes.number.isRequired,
  scoreTarget: PropTypes.number.isRequired,
  isRetake: PropTypes.bool.isRequired
}

export default QuizProgressArea
